import { Box, Button, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import * as URL from '../../../app/api/requestRequirements';

const BG = '#15151a';
const TEXT = '#f4f4f6';
const TEXT_SECONDARY = 'rgba(244,244,246,0.6)';
const BRAND_RED = '#c0392b';

function Error() {
    const navigate = useNavigate();
    const currentUser = useSelector((state: RootState) => state.session.currentUser);

    function handleBackHome() {
        if (currentUser) {
            navigate(`/users/${currentUser.nickname}/contents`);
        } else {
            navigate(URL.SIGNIN_ENDPOINT);
        }
    }

    return (
        <Box sx={{
            minHeight: '100vh',
            bgcolor: BG,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
        }}>
            <Typography variant="h1" fontWeight={700} sx={{ color: BRAND_RED, lineHeight: 1 }}>
                404
            </Typography>
            <Typography variant="h6" fontWeight={600} color={TEXT}>
                Page not found
            </Typography>
            <Typography variant="body2" sx={{ color: TEXT_SECONDARY, mb: 3 }}>
                The page you're looking for doesn't exist.
            </Typography>
            <Button
                variant="contained"
                onClick={handleBackHome}
                sx={{
                    bgcolor: BRAND_RED,
                    '&:hover': { bgcolor: '#a93226' },
                    textTransform: 'none',
                    px: 4,
                    py: 1.2,
                }}
            >
                Back Home
            </Button>
        </Box>
    );
}

export default Error;
